import { render, staticRenderFns } from "./batchBudgetModal.vue?vue&type=template&id=65297ab8&scoped=true"
import script from "./batchBudgetModal.vue?vue&type=script&lang=js"
export * from "./batchBudgetModal.vue?vue&type=script&lang=js"
import style0 from "./batchBudgetModal.vue?vue&type=style&index=0&id=65297ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65297ab8",
  null
  
)

export default component.exports